import * as React from "react";

const ActionBar = ({
  action,
  count,
  onClick,
}: {
  action: "add" | "remove";
  count: number;
  onClick: () => void;
}) => {
  const label =
    action === "add"
      ? `ADD ${count} SELECTED TO WHITELIST`
      : `REMOVE ${count} SELECTED FROM WHITELIST`;

  return (
    <button
      onClick={onClick}
      className="w-full text-[20px] bg-primary-blue text-center  py-[10px] px-[15px] hover:opacity-80"
    >
      {label}
    </button>
  );
};

export default ActionBar;
